import { useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Basic hook for getting URL search parameters
 * Returns a URLSearchParams object for manual parameter extraction
 * 
 * For enhanced functionality with automatic type conversion and easier usage,
 * consider using useUrlParams or useUrlParam from './useUrlParams'
 * 
 * @returns {URLSearchParams} - URLSearchParams object
 * 
 * @example
 * const query = useQuery();
 * const id = query.get('id');
 * const name = query.get('name');
 */
export const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
}